const STATUS = {
  pendente: { label: "Pendente", classes: "text-amber-400 bg-amber-400/10 border-amber-400/20" },
  em_andamento: { label: "Em andamento", classes: "text-blue-400 bg-blue-400/10 border-blue-400/20" },
  aguardando_peca: { label: "Aguardando peça", classes: "text-fuchsia-300 bg-fuchsia-400/10 border-fuchsia-400/20" },
  concluido: { label: "Concluído", classes: "text-emerald-400 bg-emerald-400/10 border-emerald-400/20" },
  entregue: { label: "Entregue", classes: "text-emerald-300 bg-emerald-500/15 border-emerald-500/30" },
  cancelado: { label: "Cancelado", classes: "text-rose-400 bg-rose-400/10 border-rose-400/20" },
};

export default function StatusBadge({ status }) {
  const s = STATUS[status] || { label: status, classes: "text-slate-300 bg-white/5 border-white/10" };
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border text-xs font-medium ${s.classes}`}
      data-testid={`status-badge-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
}

export const STATUS_OPTIONS = Object.entries(STATUS).map(([value, { label }]) => ({ value, label }));
